module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/wymiary-5bd747f9.png";